<div #stickyMenu [class.sticky]="sticky">
  <div class="my-cart-container">
    <div class="" aria-label="Order Summary">
      <form [formGroup]="form">
        <div class="row">
          <div class="col s12">
            <mat-form-field>
              <input matInput name="firstName" placeholder="First Name" [formControl]="firstName" required />
              <mat-error *ngIf="firstName?.errors?.required">
                <fa-icon icon="exclamation-triangle"></fa-icon>
                Please enter your first name.
              </mat-error>
            </mat-form-field>
            <mat-form-field>
              <input matInput name="lastName" placeholder="Last Name" [formControl]="lastName" required />
              <mat-error *ngIf="lastName?.errors?.required">
                <fa-icon icon="exclamation-triangle"></fa-icon>
                Please enter your last name.
              </mat-error>
            </mat-form-field>
            <mat-form-field>
              <input
                matInput
                name="phone"
                placeholder="Phone"
                [formControl]="phoneNumber"
                [textMask]="{ mask: mask }"
                required
              />
              <mat-error *ngIf="phoneNumber?.errors?.required">
                <fa-icon icon="exclamation-triangle"></fa-icon>
                Please enter your phone number.
              </mat-error>
              <mat-error *ngIf="phoneNumber.errors?.phoneLength">
                <fa-icon icon="exclamation-triangle"></fa-icon>
                Phone number must have 10 numbers.
              </mat-error>
              <mat-error *ngIf="!phoneNumber.errors?.phoneLength && phoneNumber.errors?.phoneEqualNumbers">
                <fa-icon icon="exclamation-triangle"></fa-icon>
                Phone numbers must be distinct.
              </mat-error>
            </mat-form-field>
            <mat-form-field>
              <input matInput type="email" name="email" placeholder="Email Address" [formControl]="email" required />
              <mat-error *ngIf="email?.errors?.required">
                <fa-icon icon="exclamation-triangle"></fa-icon>
                Please enter your email address.
              </mat-error>
              <mat-error *ngIf="email?.errors?.email">
                <fa-icon icon="exclamation-triangle"></fa-icon>
                Invalid email address.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
      <div class="btn-group mt-10 mb-10">
        <button
          class="btn btn-primary"
          data-event-cate="Cart"
          type="button"
          [disabled]="isLoading || form.invalid"
          (click)="onSubmit()"
        >
          Send "My Favorites"
          <fa-icon *ngIf="isLoading" icon="spinner" [spin]="true"></fa-icon>
        </button>
      </div>
    </div>
  </div>
</div>
